import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BeneficiaryComponent } from '@app/beneficiary/beneficiary.component';
import { NgbModule } from '../../../node_modules/@ng-bootstrap/ng-bootstrap';

@NgModule({
  imports: [
    CommonModule,
    NgbModule
  ],
  exports: [BeneficiaryComponent],
  declarations: [BeneficiaryComponent]
})
export class BeneficiaryModule { }
